import React from "react"
import { observer, useLocalStore } from "mobx-react"
import { Button, Flex, Typography } from "antd"
import classNames from "classnames"

import { LoadingBlock } from "@src/app/components/LoadingBlock"
import { capitalizeFirstLetter } from "@src/shared/utils/capitalizeFirstLetter"
import { MerchantStatistic } from "@src/widgets/merchantStats/classes/MerchantStats"
import { StatsPeriods } from "@src/widgets/merchantStats/constants"
import { MerchStats } from "@src/widgets/merchantStats/ui/MerchStats"
import css from "./index.module.css"

export const MerchantStats: React.FC = observer(() => {
  const stats = useLocalStore(() => new MerchantStatistic())

  const options = StatsPeriods.map((p) => ({
    label: capitalizeFirstLetter(p),
    value: p,
  }))

  return (
    <Flex className={css.wrap} gap={16} vertical>
      <Flex align="center" justify="space-between">
        <Typography.Title className={css.title} style={{ margin: 0 }}>
          Analytics
        </Typography.Title>

        <Flex align="center" gap={8} justify="space-between">
          {options.map((option, index) => (
            <Button
              className={classNames({
                [`${css.periodButtonActive}`]: stats.period === option.value,
              })}
              key={option.value}
              onClick={() => stats.changePeriod(option.value)}
              size="middle"
            >
              {option.label}
            </Button>
          ))}
        </Flex>
      </Flex>

      {stats.isLoading ? (
        <LoadingBlock />
      ) : (
        <MerchStats
          activePeriod={stats.period}
          blocks={stats.rawData}
          chart={stats.chartData}
        />
      )}
    </Flex>
  )
})
